import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import Dialog from '@material-ui/core/Dialog';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TextField from '@material-ui/core/TextField';
import AddCircle from '@material-ui/icons/AddCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import SearchIcon from '@material-ui/icons/Search';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { isMobile } from '../utils/MobileCheck';

import { IMessage } from '../actions/message';
import {
	ICareerSearchCondition,
	ICareerSearchConditionDispItem,
	ICareerSearchDetailCondition,
	ICategoryMst,
	ISelectedCareer,
	ISkillCode,
	openSearchCondCategorySelect,
	setCareerSearchCondition,
	setDetailSelectedCareers,
} from '../actions/search';
import CareerCategoryTree from '../components/CareerCategoryTree';
import CustomDatePicker from '../components/CustomDatePicker';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import i18next from '../resources/i18n';
import ScenarioFactory from '../scenario/SearchScenarioFactory';
import { CMItemCode, isValid as isValidCm } from '../utils/CMData';
import FormLabel from '../utils/FormLabelWrapper';
import InputCheck from '../utils/InputCheck';
import { getSystemMst, isValid, MasterItemCode } from '../utils/MasterData';

const styles = (theme: Theme) =>
	createStyles({
		careerTypes: {
			marginTop: theme.spacing(2),
		},
		checkbox: {
			height: 36,
			width: 36,
		},
		classStyles: {
			alignItems: 'top',
			display: 'inline-block',
		},
		classStylesItem: {
			display: 'inline-block',
			marginLeft: '30px',
		},
		container: {
			borderBottom: `1px solid ${theme.palette.primary.main}`,
			marginBottom: theme.spacing(3),
			paddingBottom: theme.spacing(2),
		},
		formControl: {
			minWidth: 120,
		},
		fullWidth: {
			width: '100%',
		},
		iconAdd: {
			color: green[500],
		},
		iconAddHidden: {
			visibility: 'hidden',
		},
		iconRemove: {
			color: red[500],
		},
		root: {
			flexGrow: 1,
			margin: 'auto',
			maxWidth: 510,
			padding: 24,
		},
	});

interface IState {
	categoryName: string;
	selectedCategories: ICategoryMst[];
	dialogOpen: boolean;
	messages: IMessage[];
	skillMainList: string[];
	skillOtherList: string[];
	skillMainCodeList: ISkillCode[];
	skillOtherCodeList: ISkillCode[];
}

/**
 * 詳細検索条件
 */
class CareerDetailSearchCondition extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			categoryName: '',
			dialogOpen: false,
			messages: [],
			selectedCategories: [],
			skillMainCodeList: [],
			skillMainList: [],
			skillOtherCodeList: [],
			skillOtherList: [],
		};

		this.changeDate = this.changeDate.bind(this);

		// 詳細検索の表示情報取得
		this.props.fetchSearchConditionDispInfo(this.props.token);
	}

	public render() {
		const {
			classes,
			careerCategoryMsts,
			curriculumCategoryMsts,
			skillCategoryMsts,
		} = this.props;
		const { searchCondition, searchConditionDispInfo } = this.props;
		const useJinjiZokusei = getSystemMst(MasterItemCode.USE_JINJI_ZOKUSEI);
		const cmFlg: boolean = isValidCm(CMItemCode.CM_ENABLED);
		return (
			<Dialog
				open={this.props.open}
				onClose={this.props.onClose}
				maxWidth="md"
			>
				<div className={classes.root}>
					<Grid
						container={true}
						spacing={3}
						className={classes.container}
					>
						<Grid item={true}>
							<TextField
								autoFocus={true}
								label={i18next.t(
									'CareerDetailSearchCondition_0001'
								)}
								id="freeword"
								value={searchCondition.freeword}
								onChange={this.changeConditionForm}
							/>
						</Grid>
					</Grid>

					<Grid
						container={true}
						spacing={3}
						alignItems={isMobile() ? 'flex-start' : 'flex-end'}
						direction={isMobile() ? 'column' : 'row'}
						className={classes.container}
					>
						<Grid item={true}>
							<CustomDatePicker
								label={i18next.t(
									'CareerDetailSearchCondition_0002'
								)}
								helperText={i18next.t(
									'CareerDetailSearchCondition_0003'
								)}
								name="startDate"
								value={searchCondition.startDate}
								onChange={this.changeDate}
							/>
						</Grid>
						<Grid item={true}>
							{i18next.t('CareerDetailSearchCondition_0004')}
						</Grid>
						<Grid item={true}>
							<CustomDatePicker
								helperText={i18next.t(
									'CareerDetailSearchCondition_0005'
								)}
								name="endDate"
								value={searchCondition.endDate}
								onChange={this.changeDate}
							/>
						</Grid>
					</Grid>

					<Grid
						container={true}
						spacing={3}
						className={classes.container}
					>
						<Grid item={true}>
							<FormLabel component="legend">
								{i18next.t('CareerDetailSearchCondition_0006')}
							</FormLabel>
							<RadioGroup
								aria-label="career-type"
								name="careerType"
								value={searchCondition.careerType}
								onChange={this.changeConditionForm}
							>
								<Grid className={classes.classStyles}>
									<FormControlLabel
										value="0"
										control={<Radio />}
										label={i18next.t(
											'CareerDetailSearchCondition_0007'
										)}
									/>
								</Grid>
								<Grid className={classes.classStylesItem}>
									<FormGroup row={!isMobile()}>
										<FormControlLabel
											control={
												<Checkbox
													id="elearning"
													checked={
														searchCondition.elearning
													}
													value="elearning"
													color="primary"
													disabled={
														!(
															searchCondition.careerType ===
															'0'
														)
													}
													onChange={
														this.changeConditionForm
													}
												/>
											}
											label={i18next.t(
												'CareerDetailSearchCondition_0008'
											)}
										/>
										{isValid(
											MasterItemCode.CAREER_TYPE_CONTROL
										) && (
											<FormControlLabel
												control={
													<Checkbox
														id="shugo"
														checked={
															searchCondition.shugo
														}
														value="shugo"
														color="primary"
														disabled={
															!(
																searchCondition.careerType ===
																'0'
															)
														}
														onChange={
															this
																.changeConditionForm
														}
													/>
												}
												label={i18next.t(
													'CareerDetailSearchCondition_0009'
												)}
											/>
										)}
										{isValid(
											MasterItemCode.CAREER_TYPE_CONTROL
										) && (
											<FormControlLabel
												control={
													<Checkbox
														id="tuusin"
														checked={
															searchCondition.tuusin
														}
														value="tuusin"
														color="primary"
														disabled={
															!(
																searchCondition.careerType ===
																'0'
															)
														}
														onChange={
															this
																.changeConditionForm
														}
													/>
												}
												label={i18next.t(
													'CareerDetailSearchCondition_0010'
												)}
											/>
										)}
									</FormGroup>
								</Grid>
								{!isMobile() && (
									<>
										<Grid className={classes.classStyles}>
											{cmFlg ? (
												<FormControlLabel
													value="10"
													control={<Radio />}
													label={i18next.t(
														'CareerDetailSearchCondition_0011'
													)}
												/>
											) : (
												<></>
											)}
											{this.getSkillTypeBrElement}
										</Grid>
										<Grid
											className={classes.classStylesItem}
										>
											{this.renderSkillSyubetu(
												classes,
												searchCondition
											)}
											{this.renderSkillOtherSyubetu(
												classes,
												searchCondition
											)}
										</Grid>
									</>
								)}

								<Grid className={classes.classStyles}>
									<FormControlLabel
										value="90"
										control={<Radio />}
										label={i18next.t(
											'CareerDetailSearchCondition_0012'
										)}
									/>
								</Grid>
							</RadioGroup>
						</Grid>
					</Grid>

					<Grid
						container={true}
						spacing={3}
						className={classes.container}
					>
						<Grid item={true}>
							<FormControl className={classes.formControl}>
								<TextField
									label={i18next.t(
										'CareerDetailSearchCondition_0013'
									)}
									id="categoryName"
									value={this.state.categoryName}
									disabled={true}
									style={{ width: '200px' }}
								/>
								<Dialog
									open={
										this.props
											.isOpenSearchDetailCondCategory
									}
									onClose={this.closeSelectCategory}
								>
									{searchCondition.careerType === '0' &&
										careerCategoryMsts.map(
											(category: ICategoryMst) => (
												<CareerCategoryTree
													category={category}
													onChangeCheckbox={
														this.onChangeCheckbox
													}
													selectedCategories={
														this.state
															.selectedCategories
													}
												/>
											),
											this
										)}
									{searchCondition.careerType === '10' &&
										skillCategoryMsts.map(
											(category: ICategoryMst) => (
												<CareerCategoryTree
													category={category}
													onChangeCheckbox={
														this.onChangeCheckbox
													}
													selectedCategories={
														this.state
															.selectedCategories
													}
												/>
											),
											this
										)}
									{searchCondition.careerType === '90' &&
										curriculumCategoryMsts.map(
											(category: ICategoryMst) => (
												<CareerCategoryTree
													category={category}
													onChangeCheckbox={
														this.onChangeCheckbox
													}
													selectedCategories={
														this.state
															.selectedCategories
													}
												/>
											),
											this
										)}
									<Button
										color="primary"
										variant="contained"
										onClick={this.setCategory}
									>
										{i18next.t(
											'CareerDetailSearchCondition_0014'
										)}
									</Button>
								</Dialog>
							</FormControl>
						</Grid>
						<Grid item={true}>
							<IconButton onClick={this.openSelectCategory}>
								<SearchIcon />
							</IconButton>
							<FormControlLabel
								control={
									<Checkbox
										id="lowerFlg"
										checked={searchCondition.lowerFlg}
										value="1"
										color="primary"
										onChange={this.changeConditionForm}
									/>
								}
								label={i18next.t(
									'CareerDetailSearchCondition_0015'
								)}
							/>
						</Grid>
					</Grid>

					{useJinjiZokusei !== 'N' && (
						<Grid
							container={true}
							spacing={3}
							className={classes.container}
						>
							<Grid item={true}>
								<FormLabel component="legend">
									{i18next.t(
										'CareerDetailSearchCondition_0016'
									)}
								</FormLabel>
								<FormGroup row={!isMobile()}>
									<FormControlLabel
										control={
											<Checkbox
												id="position"
												checked={
													searchCondition.position
												}
												value="1"
												color="primary"
												onChange={
													this.changeConditionForm
												}
											/>
										}
										label={i18next.t(
											'CareerDetailSearchCondition_0017'
										)}
									/>
									<FormControlLabel
										control={
											<Checkbox
												id="jobCategory"
												checked={
													searchCondition.jobCategory
												}
												value="1"
												color="primary"
												onChange={
													this.changeConditionForm
												}
											/>
										}
										label={i18next.t(
											'CareerDetailSearchCondition_0018'
										)}
									/>
									<FormControlLabel
										control={
											<Checkbox
												id="office"
												checked={searchCondition.office}
												value="1"
												color="primary"
												onChange={
													this.changeConditionForm
												}
											/>
										}
										label={i18next.t(
											'CareerDetailSearchCondition_0019'
										)}
									/>
								</FormGroup>
							</Grid>
						</Grid>
					)}

					<Grid
						container={true}
						spacing={3}
						className={classes.container}
					>
						<Grid item={true}>
							<FormLabel component="legend">
								{i18next.t('CareerDetailSearchCondition_0020')}
							</FormLabel>
							<FormControlLabel
								control={
									<Checkbox
										id="onlyWanted"
										checked={searchCondition.onlyWanted}
										value="1"
										color="primary"
										onChange={this.changeConditionForm}
									/>
								}
								label={i18next.t(
									'CareerDetailSearchCondition_0021'
								)}
							/>
						</Grid>
					</Grid>

					{!isMobile() && (
						<Grid
							container={true}
							spacing={3}
							className={classes.container}
						>
							<Grid item={true} xs={true}>
								<FormLabel component="legend">
									{i18next.t(
										'CareerDetailSearchCondition_0022'
									)}
								</FormLabel>
							</Grid>
							{searchCondition.detail.map(
								(
									item: ICareerSearchDetailCondition,
									index: number
								): JSX.Element => (
									<Grid
										key={index}
										container={true}
										alignItems="center"
									>
										<Grid item={true} xs={3}>
											<IconButton
												onClick={
													this.removeDetailCondition
												}
												data-index={index}
											>
												<RemoveCircle
													className={
														classes.iconRemove
													}
												/>
											</IconButton>
											{searchCondition.detail.length -
												1 !==
												index && (
												<IconButton
													className={
														classes.iconAddHidden
													}
													onClick={
														this.addDetailCondition
													}
													data-index={index}
												>
													<AddCircle />
												</IconButton>
											)}
											{searchCondition.detail.length -
												1 ===
												index && (
												<IconButton
													onClick={
														this.addDetailCondition
													}
													data-index={index}
												>
													<AddCircle
														className={
															classes.iconAdd
														}
													/>
												</IconButton>
											)}
										</Grid>
										<Grid item={true} xs={3}>
											<Select
												id="type"
												value={item.type}
												input={
													<Input
														name="type"
														id="type"
													/>
												}
												autoWidth={true}
												data-index={index}
												onChange={this.changeDetailType}
												displayEmpty={true}
											>
												{searchConditionDispInfo.generalList.map(
													(
														member: ICareerSearchConditionDispItem,
														memberIdx: number
													): JSX.Element => (
														<MenuItem
															key={memberIdx}
															value={member.id}
															data-index={index}
															data-selectedindex={
																memberIdx
															}
														>
															{i18next.t(
																member.name,
																{ ns: 'force' }
															)}
														</MenuItem>
													)
												)}
											</Select>
										</Grid>
										<Grid item={true} xs={6}>
											{item.__type === 'text' && (
												<TextField
													id={index + ''}
													value={item.text}
													onChange={
														this.changeDetailText
													}
													className={
														classes.fullWidth
													}
												/>
											)}
											{item.__type === 'select' && (
												<Select
													id="text"
													value={
														item.__multiselectValues
													}
													multiple={true}
													input={
														<Input
															name="text"
															id="text"
														/>
													}
													autoWidth={true}
													data-index={index}
													onChange={
														this.changeDetailSelect
													}
													displayEmpty={true}
													className={
														classes.fullWidth
													}
												>
													{searchConditionDispInfo[
														item.type
													].map(
														(
															selectItem: any,
															itemIdx: number
														): JSX.Element => (
															<MenuItem
																key={itemIdx}
																value={itemIdx}
																data-index={
																	index
																}
															>
																{
																	selectItem.value
																}
															</MenuItem>
														)
													)}
												</Select>
											)}
										</Grid>
									</Grid>
								)
							)}
						</Grid>
					)}

					{isMobile() && (
						<Grid
							container={true}
							spacing={3}
							className={classes.container}
						>
							<Grid item={true} xs={true}>
								<FormLabel component="legend">
									{i18next.t(
										'CareerDetailSearchCondition_0022'
									)}
								</FormLabel>
							</Grid>
							{searchCondition.detail.map(
								(
									item: ICareerSearchDetailCondition,
									index: number
								): JSX.Element => (
									<Grid
										key={index}
										container={true}
										alignItems="center"
										direction="column"
									>
										<div
											style={{
												alignItems: 'center',
												display: 'flex',
												justifyContent: 'space-between',
												width: '100%',
											}}
										>
											<div style={{ width: '50%' }}>
												<IconButton
													onClick={
														this
															.removeDetailCondition
													}
													data-index={index}
												>
													<RemoveCircle
														className={
															classes.iconRemove
														}
													/>
												</IconButton>
												{searchCondition.detail.length -
													1 !==
													index && (
													<IconButton
														className={
															classes.iconAddHidden
														}
														onClick={
															this
																.addDetailCondition
														}
														data-index={index}
													>
														<AddCircle />
													</IconButton>
												)}
												{searchCondition.detail.length -
													1 ===
													index && (
													<IconButton
														onClick={
															this
																.addDetailCondition
														}
														data-index={index}
													>
														<AddCircle
															className={
																classes.iconAdd
															}
														/>
													</IconButton>
												)}
											</div>
											<div style={{ width: '50%' }}>
												<Select
													id="type"
													value={item.type}
													input={
														<Input
															name="type"
															id="type"
														/>
													}
													autoWidth={true}
													data-index={index}
													onChange={
														this.changeDetailType
													}
													displayEmpty={true}
												>
													{searchConditionDispInfo.generalList.map(
														(
															member: ICareerSearchConditionDispItem,
															memberIdx: number
														): JSX.Element => (
															<MenuItem
																key={memberIdx}
																value={
																	member.id
																}
																data-index={
																	index
																}
																data-selectedindex={
																	memberIdx
																}
															>
																{i18next.t(
																	member.name,
																	{
																		ns:
																			'force',
																	}
																)}
															</MenuItem>
														)
													)}
												</Select>
											</div>
										</div>
										<div style={{ width: '100%' }}>
											{item.__type === 'text' && (
												<TextField
													id={index + ''}
													value={item.text}
													onChange={
														this.changeDetailText
													}
													className={
														classes.fullWidth
													}
												/>
											)}
											{item.__type === 'select' && (
												<Select
													id="text"
													value={
														item.__multiselectValues
													}
													multiple={true}
													style={{
														maxWidth: '240px',
													}}
													input={
														<Input
															name="text"
															id="text"
														/>
													}
													autoWidth={true}
													data-index={index}
													onChange={
														this.changeDetailSelect
													}
													displayEmpty={true}
													className={
														classes.fullWidth
													}
												>
													{searchConditionDispInfo[
														item.type
													].map(
														(
															selectItem: any,
															itemIdx: number
														): JSX.Element => (
															<MenuItem
																key={itemIdx}
																value={itemIdx}
																data-index={
																	index
																}
															>
																{
																	selectItem.value
																}
															</MenuItem>
														)
													)}
												</Select>
											)}
										</div>
									</Grid>
								)
							)}
						</Grid>
					)}

					<Grid
						container={true}
						spacing={3}
						className={classes.container}
						justify="flex-end"
					>
						<Grid item={true}>
							<Button
								variant="contained"
								color="primary"
								onClick={this.search}
							>
								<SearchIcon />
								{i18next.t('CareerDetailSearchCondition_0023')}
							</Button>
						</Grid>
					</Grid>
				</div>
				<MessageDialog
					open={this.state.dialogOpen}
					showCancelButton={false}
					title={i18next.t('CareerDetailSearchCondition_0024')}
					contents={this.state.messages}
					onClose={this.onDialogClose}
					onClickOk={this.onDialogClose}
				/>
			</Dialog>
		);
	}

	/**
	 * スキル種別を表示する。
	 */
	public renderSkillSyubetu = (
		classes: any,
		searchCondition: ICareerSearchCondition
	) => {
		const cmFlg: boolean = isValidCm(CMItemCode.CM_ENABLED);
		if (cmFlg) {
			const fcode = (code: string) => {
				if (code === 'SystemSkillQualification') {
					// 資格
					return 'qualification';
				} else if (code === 'SystemSkillWorkExperience') {
					// 業務経験
					return 'workExperience';
				} else if (code === 'SystemSkillAssessment') {
					// スキル診断
					return 'assessment';
				} else {
					return code;
				}
			};
			let codeList: ISkillCode[] = [];
			for (const obj of this.state.skillMainCodeList) {
				const code = obj.id;
				if (
					code === 'SystemSkillQualification' ||
					code === 'SystemSkillWorkExperience' ||
					code === 'SystemSkillAssessment'
				) {
					if (code === 'SystemSkillQualification') {
						obj.displayOrder = 0;
					}
					if (code === 'SystemSkillWorkExperience') {
						obj.displayOrder = 1;
					}
					if (code === 'SystemSkillAssessment') {
						obj.displayOrder = 2;
					}
					// 資格
					// 業務経験
					// スキル診断
					codeList.push(obj);
				}
			}
			codeList = codeList.sort((a: ISkillCode, b: ISkillCode) => {
				return a.displayOrder - b.displayOrder;
			});
			return (
				<FormGroup row={true}>
					{codeList.map((obj, index) => {
						return (
							<FormControlLabel
								control={
									<Checkbox
										id={fcode(obj.id)}
										checked={searchCondition[fcode(obj.id)]}
										value={fcode(obj.id)}
										color="primary"
										disabled={
											!(
												searchCondition.careerType ===
												'10'
											)
										}
										data-skillkey={obj.id}
										// tslint:disable-next-line:jsx-no-lambda
										onChange={e => {
											this.changeSkillConditionForm(
												e,
												obj.id
											);
										}}
									/>
								}
								label={i18next.t(obj.name, { ns: 'force' })}
								key={index}
							/>
						);
					})}
				</FormGroup>
			);
		} else {
			return <></>;
		}
	};

	/**
	 * スキル種別のレイアウト用Brを取得する。
	 */
	public getSkillTypeBrElement = () => {
		return this.state.skillOtherCodeList.map((otherCode, index) => {
			return <br key={index} />;
		});
	};

	/**
	 * スキルその他種別を表示する。
	 */
	public renderSkillOtherSyubetu = (
		classes: any,
		searchCondition: ICareerSearchCondition
	) => {
		const cmFlg: boolean = isValidCm(CMItemCode.CM_ENABLED);
		if (cmFlg) {
			const isChecked = (code: string) => {
				let skillType: string;
				for (skillType of this.props.searchCondition.skillTypeList) {
					if (skillType === code) {
						return true;
					}
				}

				return false;
			};
			return (
				<FormGroup row={false}>
					{this.state.skillOtherCodeList.map((obj, index) => {
						return (
							<FormControlLabel
								control={
									<Checkbox
										id={obj.id}
										checked={isChecked(obj.id)}
										value={obj.id}
										color="primary"
										disabled={
											!(
												searchCondition.careerType ===
												'10'
											)
										}
										data-skillkey={obj.id}
										// tslint:disable-next-line:jsx-no-lambda
										onChange={e => {
											this.changeSkillConditionForm(
												e,
												obj.id
											);
										}}
									/>
								}
								label={obj.name}
								key={index}
							/>
						);
					})}
				</FormGroup>
			);
		} else {
			return <></>;
		}
	};

	public componentDidMount() {
		const cmFlg: boolean = isValidCm(CMItemCode.CM_ENABLED);
		if (cmFlg) {
			const skillMainList: string[] = [];
			const skillOtherList: string[] = [];
			const skillMainCodeList: ISkillCode[] = [];
			const skillOtherCodeList: ISkillCode[] = [];
			for (const obj of this.props.skillCodeList) {
				if (
					obj.id === 'SystemSkillQualification' ||
					obj.id === 'SystemSkillWorkExperience' ||
					obj.id === 'SystemSkillAssessment'
				) {
					skillMainList.push(obj.id);
					skillMainCodeList.push(obj);
				} else {
					skillOtherList.push(obj.id);
					skillOtherCodeList.push(obj);
				}
			}

			this.setState({
				skillMainCodeList,
				skillMainList,
				skillOtherCodeList,
				skillOtherList,
			});
		}
	}

	/**
	 * ダイアログクローズハンドラ
	 */
	protected onDialogClose = () => {
		this.setState({
			dialogOpen: false,
		});
	};

	/**
	 * 検索条件変更
	 */
	protected changeConditionForm = (
		event: React.ChangeEvent<HTMLInputElement>,
		value?: any
	) => {
		const target = event.target as HTMLInputElement;
		const newObj: ICareerSearchCondition = {
			...this.props.searchCondition,
		};
		const val = value !== undefined ? value : target.value;

		if (target.id && target.id !== '') {
			newObj[target.id] = val;
		} else {
			newObj[target.name] = val;
		}

		// 研修種別が変わった場合は、分類選択条件をクリア
		if (target.id === 'careerType' || target.name === 'careerType') {
			newObj.categoryId = '';
			if (target.value === '90') {
				newObj.elearning = false;
				newObj.shugo = false;
				newObj.tuusin = false;
				newObj.qualification = false;
				newObj.workExperience = false;
				newObj.assessment = false;
				newObj.sonota = false;
				newObj.skillTypeList = [];
			} else if (target.value === '10') {
				newObj.elearning = false;
				newObj.shugo = false;
				newObj.tuusin = false;
				newObj.qualification = true;
				newObj.workExperience = true;
				newObj.assessment = true;
				newObj.sonota = true;
				newObj.skillTypeList = [];
				for (const t of this.state.skillMainList) {
					newObj.skillTypeList.push(t);
				}
				for (const t of this.state.skillOtherList) {
					newObj.skillTypeList.push(t);
				}
			} else {
				newObj.qualification = false;
				newObj.workExperience = false;
				newObj.assessment = false;
				newObj.sonota = false;
				newObj.skillTypeList = [];
				newObj.elearning = true;
				newObj.shugo = true;
				newObj.tuusin = true;
			}
			this.setState({ selectedCategories: [], categoryName: '' });
		}
		this.props.setCareerSearchCondition(newObj);
	};

	/**
	 * スキル検索条件変更
	 */
	protected changeSkillConditionForm(
		event: React.ChangeEvent<HTMLInputElement>,
		id: string
	) {
		const target = event.target as HTMLInputElement;
		const newObj: ICareerSearchCondition = {
			...this.props.searchCondition,
		};

		if (target.id && target.id !== '') {
			newObj[target.id] = target.checked;
		} else {
			newObj[target.name] = target.checked;
		}

		let skillTypeList: string[] = newObj.skillTypeList;
		if (target.checked) {
			let hasSaved = false;
			let skillType: string;
			for (skillType of skillTypeList) {
				if (skillType === id) {
					hasSaved = true;
					break;
				}
			}

			if (!hasSaved) {
				skillTypeList.push(id);
			}
		} else {
			skillTypeList = skillTypeList.filter(skillType => {
				if (skillType === id) {
					return false;
				}

				return true;
			});
		}

		newObj.skillTypeList = skillTypeList;
		this.props.setCareerSearchCondition(newObj);
	}

	/**
	 * 日付変更処理
	 * @param name プロパティ名
	 * @param dateStr 日付
	 */
	protected changeDate(name: string, dateStr: string) {
		const newObj: ICareerSearchCondition = {
			...this.props.searchCondition,
		};
		if (dateStr !== '') {
			if (name === 'startDate') {
				newObj[name] = dateStr + ' ' + '00:00';
			} else {
				newObj[name] = dateStr + ' ' + '23:59';
			}
		} else {
			newObj[name] = dateStr;
		}
		this.props.setCareerSearchCondition(newObj);
	}

	/**
	 * カテゴリ選択表示
	 */
	protected openSelectCategory = () => {
		// カテゴリマスタ取得
		this.props.fetchCategoryMst(
			this.props.token,
			this.props.searchCondition.careerType
		);
	};

	/**
	 * カテゴリ選択非表示
	 */
	protected closeSelectCategory = () => {
		this.props.openSearchCondCategorySelect(false);
	};

	/**
	 * カテゴリ選択
	 */
	protected setCategory = () => {
		let categoryName = '';
		const newObj: ICareerSearchCondition = {
			...this.props.searchCondition,
		};
		if (
			this.state.selectedCategories &&
			this.state.selectedCategories.length === 1
		) {
			categoryName = this.state.selectedCategories[0].textPath;
			newObj.categoryId = this.state.selectedCategories[0].id;
		} else {
			categoryName = '';
			newObj.categoryId = '';
		}
		this.props.setCareerSearchCondition(newObj);
		this.props.openSearchCondCategorySelect(false);
		this.setState({ categoryName });
	};

	/**
	 * 分類選択
	 */
	protected onChangeCheckbox = (checked: boolean, category: ICategoryMst) => {
		if (checked) {
			const selectedCategories = [category];
			this.setState({ selectedCategories });
		} else {
			const selectedCategories: ICategoryMst[] = this.state.selectedCategories.filter(
				(c: ICategoryMst) => {
					if (category.id !== c.id) {
						return true;
					}
					return false;
				}
			);
			this.setState({ selectedCategories });
		}
	};

	/**
	 * 詳細条件削除
	 */
	protected removeDetailCondition = (
		event: React.MouseEvent<HTMLElement>
	) => {
		const index = event.currentTarget.getAttribute('data-index');

		const newObj: ICareerSearchCondition = {
			...this.props.searchCondition,
		};
		if (index && index !== '') {
			newObj.detail.splice(+index, 1);
		}
		if (newObj.detail.length === 0) {
			newObj.detail.push({
				__multiselectValues: [],
				__type: '',
				items: [],
				text: '',
				type: '',
			});
		}

		this.props.setCareerSearchCondition(newObj);
	};

	/**
	 * 詳細条件追加
	 */
	protected addDetailCondition = (event: React.MouseEvent<HTMLElement>) => {
		const index = event.currentTarget.getAttribute('data-index');

		const newObj: ICareerSearchCondition = {
			...this.props.searchCondition,
		};
		if (index && index !== '') {
			newObj.detail.push({
				__multiselectValues: [],
				__type: '',
				items: [],
				text: '',
				type: '',
			});
		}

		this.props.setCareerSearchCondition(newObj);
	};

	/**
	 * 詳細条件の種別変更
	 */
	protected changeDetailType = (
		event: React.ChangeEvent<HTMLSelectElement>
	) => {
		const { searchConditionDispInfo } = this.props;
		const index = event.currentTarget.getAttribute('data-index');
		const selectedIndex = event.currentTarget.getAttribute(
			'data-selectedindex'
		);
		if (index && index !== '' && selectedIndex && selectedIndex !== '') {
			const { id, type } = searchConditionDispInfo.generalList[
				selectedIndex
			];
			const newObj: ICareerSearchCondition = {
				...this.props.searchCondition,
			};
			newObj.detail[index] = {
				__multiselectValues: [],
				__type: type,
				items: [],
				text: '',
				type: id,
			};

			this.props.setCareerSearchCondition(newObj);
		}
	};

	/**
	 * 詳細条件のテキスト変更
	 */
	protected changeDetailText = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const index = event.target.id;
		const { value } = event.target;
		if (index && index !== '') {
			const newObj: ICareerSearchCondition = {
				...this.props.searchCondition,
			};
			newObj.detail[index].text = value;

			this.props.setCareerSearchCondition(newObj);
		}
	};

	/**
	 * 詳細条件のSelect変更
	 */
	protected changeDetailSelect = (
		event: React.ChangeEvent<HTMLSelectElement>
	) => {
		const { searchConditionDispInfo } = this.props;
		const index = event.currentTarget.getAttribute('data-index');
		const value: any = event.target.value;
		if (index && index !== '') {
			const { type } = this.props.searchCondition.detail[index];
			const dispInfo = searchConditionDispInfo[type];
			const newObj: ICareerSearchCondition = {
				...this.props.searchCondition,
			};
			newObj.detail[index].__multiselectValues = value;
			newObj.detail[index].items = [];
			if (typeof value === 'object') {
				value.map((val: string) => {
					if (dispInfo) {
						newObj.detail[index].items.push({
							companyId: dispInfo[val].companyId,
							itemId: dispInfo[val].code,
						});
					}
				});
			}

			this.props.setCareerSearchCondition(newObj);
		}
	};

	/**
	 * 検索処理
	 */
	protected search = (event: React.MouseEvent<HTMLElement>) => {
		const messages: IMessage[] = [];
		const careerTypeControl = getSystemMst(
			MasterItemCode.CAREER_TYPE_CONTROL
		);

		if (this.props.searchCondition.careerType === '0') {
			if (careerTypeControl === '0') {
				if (!this.props.searchCondition.elearning) {
					const message: IMessage = {
						content: 'LMCM_E_00543',
					};
					messages.push(message);
				}
			} else {
				if (
					!this.props.searchCondition.elearning &&
					!this.props.searchCondition.shugo &&
					!this.props.searchCondition.tuusin
				) {
					const message: IMessage = {
						content: 'LMCM_E_00542',
					};
					messages.push(message);
				}
			}
		}
		if (this.props.searchCondition.careerType === '10') {
			// スキル種別未入力チェック
			if (this.props.searchCondition.skillTypeList.length === 0) {
				const message: IMessage = {
					content: 'LMCM_E_15018',
					replacements: [
						this.state.skillOtherCodeList
							.map((otherCode, index) => {
								return '、「' + otherCode.name + '」';
							})
							.join(''),
					],
				};
				messages.push(message);
			}
		}
		const errCol: string[] = [];
		if (
			this.props.searchCondition.startDate &&
			InputCheck.chkErYYYYMMDDhhmm(
				InputCheck.convertDate(this.props.searchCondition.startDate)
			)
		) {
			errCol.push(i18next.t('CareerDetailSearchCondition_0025'));
		} else if (
			this.props.searchCondition.startDate &&
			(this.props.searchCondition.startDate < '1900/01/01 00:00' ||
				this.props.searchCondition.startDate > '2100/01/01 23:59')
		) {
			errCol.push(i18next.t('CareerDetailSearchCondition_0025'));
		}
		if (
			this.props.searchCondition.endDate &&
			InputCheck.chkErYYYYMMDDhhmm(
				InputCheck.convertDate(this.props.searchCondition.endDate)
			)
		) {
			errCol.push(i18next.t('CareerDetailSearchCondition_0026'));
		} else if (
			this.props.searchCondition.endDate &&
			(this.props.searchCondition.endDate < '1900/01/01 00:00' ||
				this.props.searchCondition.endDate > '2100/01/01 23:59')
		) {
			errCol.push(i18next.t('CareerDetailSearchCondition_0026'));
		}
		if (errCol.length > 0) {
			const message: IMessage = {
				content: 'CHK_E_0018',
				replacements: [InputCheck.makeErrColListString(errCol)],
			};
			messages.push(message);
		}

		if (
			this.props.searchCondition.startDate &&
			!InputCheck.chkErYYYYMMDDhhmm(
				InputCheck.convertDate(this.props.searchCondition.startDate)
			) &&
			this.props.searchCondition.endDate &&
			!InputCheck.chkErYYYYMMDDhhmm(
				InputCheck.convertDate(this.props.searchCondition.endDate)
			)
		) {
			if (
				InputCheck.chkFuturePast(
					this.props.searchCondition.startDate,
					this.props.searchCondition.endDate
				) === 1
			) {
				const message: IMessage = {
					content: 'CHK_E_0016',
					replacements: [
						i18next.t('CareerDetailSearchCondition_0026'),
						i18next.t('CareerDetailSearchCondition_0025'),
					],
				};
				messages.push(message);
			}
		}
		// 表示
		if (messages.length !== 0) {
			this.setState({
				dialogOpen: true,
				messages,
			});
			return;
		}
		this.props.fetchDetailCareerList(
			this.props.token,
			this.props.searchCondition
		);
		this.props.setSelectedCareers([]);
		this.props.onClose();
	};
}

const mapStateToProps = (state: IRootState) => ({
	careerCategoryMsts: state.search.careerCategoryMsts,
	curriculumCategoryMsts: state.search.curriculumCategoryMsts,
	isOpenSearchDetailCondCategory: state.search.isOpenSearchDetailCondCategory,
	searchCondition: state.search.careerSearchCondition,
	searchConditionDispInfo: state.search.careerSearchConditionDispInfo,
	skillCategoryMsts: state.search.skillCategoryMsts,
	skillCodeList: state.search.skillCodeList,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCategoryMst: (token: string, careerType: string) => {
		const s = ScenarioFactory.createFetchCategoryMst(dispatch, token);
		s.run(careerType);
	},
	fetchDetailCareerList: (
		token: string,
		condition: ICareerSearchCondition
	) => {
		const s = ScenarioFactory.createFetchDetailCareerList(dispatch, token);
		s.run(condition);
	},
	fetchSearchConditionDispInfo: (token: string) => {
		const s = ScenarioFactory.createFetchSearchConditionDispInfo(
			dispatch,
			token
		);
		s.run({});
	},
	openSearchCondCategorySelect: (open: boolean) =>
		dispatch(openSearchCondCategorySelect({ open })),
	setCareerSearchCondition: (value: ICareerSearchCondition) =>
		dispatch(setCareerSearchCondition({ value })),
	setSelectedCareers: (selectedCareers: ISelectedCareer[]) =>
		dispatch(setDetailSelectedCareers({ selectedCareers })),
});

interface ICareerDetailSearchConditionProps {
	onClose: () => void;
	open: boolean;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ICareerDetailSearchConditionProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CareerDetailSearchCondition);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/CareerDetailSearchCondition.tsx